module.exports = __webpack_public_path__ + "static/media/leader.92e770c5.png";